<script>
    import { apiUrl } from "@/utils";

    export default {
        name: "ProductCardImage",
        props: {
            path: {
                type: Object,
                required: true,
            },
            image: {
                type: String,
                required: true,
            },
            offerImage: {
                type: String,
                default: "",
            },
        },
        methods: {
            apiUrl,
        },
    };
</script>

<template>
    <router-link
        :to="path"
        class="product-card-image js-lazy-load"
        tabindex="-1"
        @click.native.prevent="$emit('click')"
    >
        <img
            class="product-card-image__product"
            :data-src="apiUrl(image)"
            :src="offerImage ? apiUrl(offerImage) : ''"
            alt=""
        />
        <div class="product-card-image__loader">
            <slot></slot>
        </div>
    </router-link>
</template>

<style lang="scss">
    .product-card-image {
        position: relative;
        display: block;
        padding-bottom: 100%;
    }

    .product-card-image__product {
        @include center-absolute(0);
        z-index: 1;
        display: none;
        max-height: 100%;
        margin: auto;
        transform: scale(0.98);
        transition: 0.3s ease-in-out transform;
        animation: imageFadeIn 0.3s ease-in-out;
        &[lazy="loaded"] {
            display: block;
            & + .product-card-image__loader {
                opacity: 0;
            }
        }
    }

    .product-card-image__loader {
        opacity: 1;
    }

    @keyframes imageFadeIn {
        from {
            opacity: 0;
            transform: scale(0.9);
        }
        to {
            opacity: 1;
            transform: scale(0.98);
        }
    }
</style>
